import { PortableText } from '@portabletext/react';
import React from 'react';
import { RequirementsProps } from '../../tools/context';

interface BlockProps {
  requirements: RequirementsProps;
}

export default function Block({ requirements, ...rest }: BlockProps) {
  const components = {
    marks: {
      internalLink: ({ value, children }) => {
        const { reference, openInNewTab } = value;
        const href = reference?.slug ? `/${reference.slug}` : '#';

        return openInNewTab ? (
          <a href={href} target="_blank" rel="noopener">
            {children}
          </a>
        ) : (
          <a href={href}>{children}</a>
        );
      },
      link: ({ value, children }) => {
        const { href, openInNewTab } = value;

        return openInNewTab ? (
          <a href={href} target="_blank" rel="noopener">
            {children}
          </a>
        ) : (
          <a href={href}>{children}</a>
        );
      },
    },
  };

  return (
    <div className="Block">
      <PortableText value={rest as any} components={components as any} />
    </div>
  );
}
